import { render, staticRenderFns } from "./customerWarranty_Red.vue?vue&type=template&id=16a96132&scoped=true&"
import script from "./customerWarranty_Red.vue?vue&type=script&lang=js&"
export * from "./customerWarranty_Red.vue?vue&type=script&lang=js&"
import style0 from "./customerWarranty_Red.vue?vue&type=style&index=0&id=16a96132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a96132",
  null
  
)

export default component.exports